import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RANGE_FILTER } from '@as-react/common-types';
import { isEqual, isNullOrUndefined } from '@as-react/common-utils';
import { Box, RangeSlider } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useProductListerContext } from '../../context';
import { FilterItemContentRangeFilterInputs } from './FilterItemContentRangeFilterInputs';
export const FilterItemContentRangeFilter = ({ filter: { rangeMin = 0, rangeMax = 0, name, filterOn, filterPrefix, filterSuffix, boundaryMin, boundaryMax, filterContentType, }, onFilterItemChange, }) => {
    const { filterState: { activeFilters }, } = useProductListerContext();
    const [value, setValue] = useState({
        min: Math.floor(rangeMin),
        max: Math.ceil(rangeMax),
    });
    const [displayValue, setDisplayValue] = useState(value);
    const isValueValid = !(isNullOrUndefined(value.max) || isNullOrUndefined(value.min));
    // if there is an undefined property value in value, default to the previous legal one
    const sliderValue = (isValueValid && value) || displayValue;
    const isActive = Boolean(activeFilters && activeFilters[filterOn]);
    useEffect(() => {
        // Only set value when filter is not active
        if (!isActive) {
            setValue({
                min: Math.floor(rangeMin),
                max: Math.ceil(rangeMax),
            });
        }
    }, [rangeMin, rangeMax, isActive]);
    const handleChange = (v, finished) => {
        setValue(v);
        if (finished && !isEqual(value, displayValue)) {
            if (!isValueValid) {
                setValue(displayValue);
                return;
            }
            onFilterItemChange({
                filterOn: filterOn,
                filterOnName: name,
                filteredItems: [{ filterKey: v.min.toString() }, { filterKey: v.max.toString() }],
                filterType: RANGE_FILTER,
                filterPrefix: filterPrefix,
                filterSuffix: filterSuffix,
                filterContentType: filterContentType,
            });
            setDisplayValue(value);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingInline: "0.5", children: _jsx(RangeSlider, { id: filterOn, name: filterOn, value: sliderValue, onChange: handleChange, min: boundaryMin, max: boundaryMax }) }), _jsx(FilterItemContentRangeFilterInputs, { value: value, onChange: handleChange, min: boundaryMin, max: boundaryMax, filterPrefix: filterPrefix, filterSuffix: filterSuffix })] }));
};
